let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3MfsZ")).then(() => parcelRequire('e68Yk'));